import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { createDevolition } from '../../../../actions/marketPlaceActions'
import Button from '../../../../utils/components/Button/Button'
import Input from '../../../../utils/components/Input/Input'
import useModal from '../../../../utils/hooks/useModal'
import { addSpecificationDevolution, clearSpecificationDevolution } from '../../../actions/transferActions'
import { Table } from '../../../components/Table/Table'
import CardProductOutput from '../transfer/Cards/CardProductOutput'
import ProducDevolve from './ProductDevolve/ProducDevolve'

const CreateDevolution = ({ search, orderId, setOrderId, subOrders, getBatches, reasonsfordeletion }) => {
    const [refShow, isShow, setIsShow] = useModal(false)
    const dispatch = useDispatch()
    const [productId, setProductId] = useState(null)
    const { specificationsDevolutions } = useSelector(state => state.tranfers)
    const [batchesList, setBatchesList] = useState(new Map())
    const history = useHistory()
    return (
        <div>

            <Input placeholder='Digite el código de la compra'
                onChange={e => setOrderId(e.target.value)}
            />
            <Button text='Buscar'
                onClick={() => search()}
            />
            {
                (subOrders.length > 0) && (
                    <div>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Código</th>
                                    <th>Nombre</th>
                                    <th>Cantidad</th>
                                    <th>Precio unitario</th>
                                    <th>Precio total</th>
                                    <th>Gestionar</th>
                                </tr>
                            </thead>
                            <tbody>

                                {
                                    subOrders.map(subOrder => (
                                        <tr key={subOrder._id}>
                                            <td>{subOrder.productId.code}</td>
                                            <td> {subOrder.productId.name}</td>
                                            <td> {subOrder.orderedQuantity}</td>
                                            <td> {subOrder.unitPrice}</td>
                                            <td> {subOrder.totalPrice}</td>
                                            <td>
                                                <Button
                                                    text='Devolver'
                                                    onClick={() => {
                                                        setProductId(subOrder.productId._id)
                                                        getBatches(subOrder)
                                                        if (specificationsDevolutions.find(specification => specification.productId ===subOrder.productId._id) ===undefined) {
                                                            setBatchesList(new Map())
                                                        } else {
                                                            const batches = specificationsDevolutions.find(specification => specification.productId ===subOrder.productId._id).batches
                                                            setBatchesList(new Map(batches.map(batch => [batch.batchId, batch])))
                                                        }
                                                        console.log();

                                                        setIsShow(true)
                                                    }}
                                                />
                                            </td>

                                        </tr>
                                    ))
                                }
                            </tbody>


                        </Table>
                        <ModalBatches
                            batchesList={batchesList}
                            setBatchesList={setBatchesList}
                            reasonsfordeletion={reasonsfordeletion}
                            productId={productId}
                            close={() => {
                                setBatchesList(new Map())
                                setIsShow(false)
                                
                            }}
                            isShowModal={isShow}
                        />
                        <div>
                            <Button
                                disabled={specificationsDevolutions.filter(specifications => {
                                    const batches = specifications.batches

                                    batches.filter(batch => {
                                        return batch.reasonId && batch.quantity && batch.quantity > 0
                                    })
                                    return batches.length > 0;
                                }).length ===0}
                                onClick={() => {

                                    const specifications = specificationsDevolutions.filter(specifications => {
                                        const batches = specifications.batches

                                        batches.filter(batch => {
                                            return batch.reasonId && batch.quantity && batch.quantity > 0
                                        })
                                        return batches.length > 0;
                                    })
                                    console.log();

                                   dispatch(
                                    createDevolition({
                                        productOrderId:subOrders[0].orderId._id,
                                        specifications:specifications
                                    },history)
                                   )


                                }} text="Guardar" />
                            <Button onClick={() => {

                            }} text="Cancelar" />
                        </div>
                    </div>
                )
            }

        </div>

    )
}
const ModalBatches = ({ batchesList, setBatchesList, productId, isShowModal, close, reasonsfordeletion }) => {

    const divStyle = {
        display: isShowModal ? 'block' : 'none'
    };
    const { batchesUser } = useSelector(state => state.marketPlace)

    useEffect(() => {


        return () => {
            ///     dispatch(clearSpecificationDevolution())
        }
    }, [])


    const dispatch = useDispatch()
    //new Map(specificationsDevolutions.find(specification=>specification.productId==productId) |

    useEffect(() => {


        return () => {
            setBatchesList(new Map())
        }
    }, [])

    //    const total = Array.from(batchesList.values()).reduce((n, { quantityReceived }) => n + quantityReceived, 0);


    return (
        <>{(batchesUser.batches && batchesUser.batches.length > 0) &&
            <div style={divStyle}
                className="modal">
                <div className="modal-content modal-report-post" >

                    {
                        batchesUser.batches.map(batch => (
                            <ProducDevolve
                                key={batch._id}
                                reasonsfordeletion={reasonsfordeletion}
                                checked={batchesList.has(batch._id) && batchesList.get(batch._id).reasonId && batchesList.get(batch._id).quantity && batchesList.get(batch._id).quantity > 0}
                                expeditionDate={batch.expeditionDate}
                                expirationDate={batch.expirationDate}
                                stock={batch.quantityReceived}
                                id={batch._id}
                                reason={
                                    batchesList.has(batch._id) && batchesList.get(batch._id).reasonId
                                }
                                quantity={
                                    batchesList.has(batch._id) ? batchesList.get(batch._id).quantity : 0
                                }
                                setReason={(e) => {

                                    e.persist()
                                    setBatchesList(oldList => {
                                        const newList = new Map(oldList)
                                        if (newList.has(batch._id)) {
                                            newList.set(batch._id, {
                                                ...newList.get(batch._id),
                                                reasonId: e.target.value
                                            })
                                        } else {
                                            newList.set(batch._id, {
                                                reasonId: e.target.value
                                            })
                                        }
                                        return newList
                                    })
                                }}
                                setQuantity={(e) => {

                                    e.persist()
                                    setBatchesList(oldList => {
                                        const newList = new Map(oldList)
                                        if (newList.has(batch._id)) {
                                            newList.set(batch._id, {
                                                ...newList.get(batch._id),
                                                quantity: e.target.value,
                                                batchId: batch._id
                                            })
                                        } else {
                                            newList.set(batch._id, {
                                                quantity: e.target.value,
                                                batchId: batch._id
                                            })
                                        }
                                        return newList
                                    })
                                }}

                            />
                        ))
                    }
                    <div className='column mt-5'>
                        <Button
                            disabled={Array.from(batchesList.values()).filter(batch => batch.reasonId && batch.quantity && batch.quantity.length > 0).length ===0}
                            onClick={() => {
                                console.log();

                                dispatch(addSpecificationDevolution({
                                    productId: productId,
                                    batches: Array.from(batchesList.values())
                                }))

                                close()
                            }} text="Guardar" />
                        <Button onClick={() => {
                            close()
                        }} text="Cancelar" />
                    </div>
                </div>
            </div>
        } </>
    )
}

export default CreateDevolution